import moment from 'moment';
import create from 'zustand';

interface SnackbarState {
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  opened: boolean;
  open: ({
    message,
    type,
  }: {
    message: string;
    type: 'info' | 'success' | 'warning' | 'error';
  }) => void;
  close: () => void;
}

export const useSnackbar = create<SnackbarState>((set) => ({
  message: '',
  type: 'info',
  opened: false,
  open: ({ message, type }) => {
    set((state) => ({ ...state, message, type, opened: true }));
    setTimeout(() => {
      set((state) => ({ ...state, opened: false }));
    }, 5000);
  },
  close: () => {
    set((state) => ({ ...state, opened: false }));
  },
}));

interface RecaptchaState {
  recaptchaFailed: boolean;
  setRecaptchaFailed: (recaptchaFailed: boolean) => void;
}

export const useRecaptcha = create<RecaptchaState>((set) => ({
  recaptchaFailed: false,
  setRecaptchaFailed: (payload) => {
    set((state) => ({ ...state, recaptchaFailed: payload }));
  },
}));

export const useEventFilterState: any = create()((set, get) => ({
  location: '',
  locationAvailable: false,
  dateRangeName: 'This week',
  dateRange: {
    start: moment().startOf('week').toDate(),
    end: moment().endOf('week').toDate(),
  },
  selectedCategories: [],
  latitude: null,
  longitude: null,
}));
